// removed by extract-text-webpack-plugin
module.exports = {"hidden":"jL0ep","visuallyhidden":"_2WNI-","hide-text":"lr_Si","center":"_3nYuf","noprint":"_3B0nA","root":"_3LU0a"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/svg/Logo.scss
 ** module id = 458
 ** module chunks = 0
 **/